import React, { RefObject, createRef } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { Props } from './interfaces';
import './Button.scss';
import './Button-media.scss';

import ErrorTextBlocked from '../ErrorTextBlocked/ErrorTextBlocked';
import {Link} from "../Link/Link";

const Button = ({
  text,
  size,
  type,
  color,
  link,
  widthAll,
  onClick,
  colorText,
  disabled,
  title,
  linkOut = false,
  icon,
  blockedSend,
  showBlockedError = false,
  loading = false,
}: Props) => {
  const elLink: RefObject<HTMLAnchorElement> = createRef();
  const elButton: RefObject<HTMLButtonElement> = createRef();
  const elSpan: RefObject<HTMLSpanElement> = createRef();

  const className =
    'button' +
    `${size ? ` button_${size}` : ' button_L'}` +
    `${type ? ` button_type-${type}` : ''}` +
    `${widthAll ? ` button_width-all` : ''}` +
    `${colorText ? ` button_text-${colorText}` : ''}` +
    `${disabled ? ` button_disabled` : ''}` +
    `${icon ? ` button_icon` : ''}` +
    `${color ? ` button_${color}` : ''}` +
    `${loading ? ` button_loading` : ''}`;

  const buttonContent = loading ? <div className="button__spinner"></div> : text;

  if (linkOut) {
    return (
      <a
        href={link}
        className={className}
        onClick={onClick}
        target="_blank"
        rel="nofollow"
        ref={elLink}
        onMouseEnter={HoverButton(elLink, elSpan)}
        onMouseOut={HoverButton(elLink, elSpan)}
      >
        {text}
        <span ref={elSpan}></span>
      </a>
    );
  }

  return link ? (
    <Link
      to={link}
      className={className}
      onClick={onClick}
      ref={elLink}
      onMouseEnter={HoverButton(elLink, elSpan)}
      onMouseOut={HoverButton(elLink, elSpan)}
    >
      {text}
      <span ref={elSpan}></span>
    </Link>
  ) : (
    <>
      {showBlockedError && blockedSend.state && <ErrorTextBlocked counter={blockedSend.counter} />}
      <button
        type="submit"
        className={className}
        onClick={onClick}
        disabled={disabled || loading || (showBlockedError && blockedSend.state)}
        title={title}
        ref={elButton}
        onMouseEnter={HoverButton(elButton, elSpan)}
        onMouseOut={HoverButton(elButton, elSpan)}
      >
        {buttonContent}
        <span ref={elSpan}></span>
      </button>
    </>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(Button));

const processButtonHoverCoordinates = (e: any, button?: any, span?: any) => {
  let Top = button?.getBoundingClientRect().top;
  let Left = button?.getBoundingClientRect().left;

  if (Top && Left) {
    let relX = e.clientX - Left;
    let relY = e.clientY - Top;
    span.style.top = `${relY}px`;
    span.style.left = `${relX}px`;
  }
}

export const HoverButtonNative = (button?: any, span?: any) => (e: any) => {
  processButtonHoverCoordinates(e, button, span);
}

export const HoverButton = (button: RefObject<any>, span: RefObject<any>) => (e: any) => {
  processButtonHoverCoordinates(e, button.current, span.current);
};
